import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button, Form, FormGroup, Label,
} from 'reactstrap';
import { useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import ReactTagInput from '@pathofdev/react-tag-input';
import { validationMessages, regexPattern, handleGraphqlError } from '../../utils';
import { PLATFORM_INVITE, LOADER_MUTATION } from '../../graphql-client/mutations';

function SendInvite(props) {
  const {
    isOpen, onClose,
  } = props;
  const { addToast } = useToasts();
  const [modal, setModal] = useState(isOpen);
  const [tags, setTags] = useState([]);
  const [isEmailError, setEmailError] = useState(false);
  const [loaderValue, setLoaderValue] = useState(false);
  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: loaderValue },
  });

  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const hideModal = () => {
    toggle();
    onClose();
  };

  const addEmailTag = (newTags) => {
    setTags(newTags.map((val) => val.toLowerCase()));
    setEmailError(false);
  };

  const [platformInviteMutation] = useMutation(PLATFORM_INVITE, {
    variables: { emails: tags },
    onError(err) {
      setLoaderValue(false);
      loaderMutate();
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(response) {
      setLoaderValue(false);
      loaderMutate();
      addToast(response.platformInvite.message, { appearance: 'success' });
      onClose();
    },

  });

  return (
    <Modal isOpen={modal} className="modal-publish modal-send-invite modal-dialog-centered">
      <ModalBody>
        <h4>Invite a new Artist/Label to BYGMusic</h4>
        <Form>
          <span
            className="icon icon-cross cursor-pointer"
            onClick={hideModal}
          />
          <FormGroup>
            <Label>
              Email address
            </Label>
            <div className="modal-publish-invite-email">
              <ReactTagInput
                tags={tags}
                placeholder="Enter email address"
                editable
                readOnly={false}
                removeOnBackspace
                onChange={(newTags) => addEmailTag(newTags)}
                validator={(value) => {
                  const isEmail = regexPattern.EMAIL.test(value);
                  const isTagError = tags.includes(value.toLowerCase());
                  setEmailError(!isEmail || isTagError);
                  return (isEmail && !isTagError) && isEmail;
                }}
              />
              <span className="form-error-text">
                {' '}
                {isEmailError && validationMessages.INVALID}
                {' '}
              </span>
            </div>
          </FormGroup>
          <div className="modal-edit-artist-btn-group">
            <span
              onClick={hideModal}
            >
              Cancel
            </span>
            <Button
              color="accept"
              onClick={platformInviteMutation}
              disabled={!tags.length}
            >
              Send invite
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}

SendInvite.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SendInvite;
